import { FC, PropsWithChildren } from 'react';

import { Link, usePage } from '@inertiajs/react';

import logoDark from '../assets/logo-dark-theme.svg';
import logoLight from '../assets/logo-light-theme.svg';
import { SeoHead } from '../components/shared/SeoHead';
import { CartProvider } from '../context/cart-context';
import { useResolvedTheme } from '../hooks/useResolvedTheme';
import { Metadata } from '../types/shared';

type PageProps = {
    metadata: Metadata;
};

const Checkout: FC<PropsWithChildren> = ({ children }) => {
    const { metadata } = usePage<PageProps>().props;
    const resolvedTheme = useResolvedTheme();
    const logo = resolvedTheme === 'dark' ? logoDark : logoLight;

    return (
        <CartProvider>
            <SeoHead metadata={metadata} />

            <div className="flex min-h-screen flex-col">
                <header className="sticky top-0 z-50 w-full bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 md:border-b">
                    <div className="container flex h-14 items-center justify-between px-3 sm:h-16 sm:px-6 lg:px-8">
                        <div className="flex items-center gap-1 md:gap-6">
                            <Link href="/" className="flex items-center">
                                <img
                                    src={logo}
                                    alt="CartOn Logo"
                                    width={120}
                                    height={32}
                                    className="h-7 w-auto sm:h-8"
                                />
                            </Link>
                        </div>
                    </div>
                </header>

                {children}
            </div>
        </CartProvider>
    );
};

export default Checkout;
